import { SiteConfigManager } from '@atlas/core';

const DefaultRtlLanguages = ['FAS', 'ARA', ''];

export const isRtlLanguage = ({ lang }) => {
  const languages = SiteConfigManager.getConfig('languages', []);

  return (
    languages.some(language => lang === language.code && language.isRtl) ||
    DefaultRtlLanguages.includes(lang)
  );
};
